import React from "react";
import { Link } from "react-router-dom";

export function Logo({ variant = "lockup", className = "", to = "/" }) {
  const src = variant === "mark" ? "/brand/bloomconnect-mark.png" : "/brand/bloomconnect-logo.png";
  const img = (
    <img src={src} alt="BloomCONNECT" className={variant === "mark" ? "h-11 w-11 object-contain" : "h-12 md:h-14 w-auto object-contain"} />
  );
  if (to === null) return <span className={className}>{img}</span>;
  return <Link to={to} className={`inline-flex items-center ${className}`} aria-label="BloomCONNECT home">{img}</Link>;
}
